// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"9c189838","678":"33eb4dd5","963":"3ae7213a"}[chunkId] + ".chunk.js";
};